import { Observable, fromEvent, merge, timer } from 'rxjs';
import { debounceTime, filter, map } from 'rxjs/operators';
import { DeviceRealtimeService } from '../services/device-realtime.service';

const PING_DEBOUNCE_MS: number = 1000;

/**
 * When a view of device state should read again: every `periodMs` while the
 * tab is visible, as soon as it becomes visible again, and at once on a
 * SignalR ping (a notification, such as "gateway back online", or an
 * intrusion/edge status change). The poll alone left the page a minute behind
 * the notification it had just shown.
 */
export function liveRefresh(realtime: DeviceRealtimeService, periodMs: number): Observable<void> {
  const visible$: Observable<unknown> = fromEvent(document, 'visibilitychange').pipe(filter(() => !document.hidden));
  const tick$: Observable<unknown> = timer(periodMs, periodMs).pipe(filter(() => !document.hidden));
  const ping$: Observable<unknown> = merge(realtime.notificationEvents$, realtime.intrusionEvents$).pipe(debounceTime(PING_DEBOUNCE_MS));

  return merge(tick$, visible$, ping$).pipe(map(() => undefined));
}
